// Dated public facts shown on the informative pages (Modelos, IGNIS, Validação,
// Sobre, LIMES, Pilotos). One place to refresh; every number has a ledger source.
// Rule (Martim, 2026-10-11): the site reflects what exists today, never more.

/** The day these facts were last checked against the ledgers. */
export const STATE_DATE = '11 de outubro de 2026';

/** The model that serves the public map today and the one running in shadow.
 * Sources: docs/NOW.md LIVE STATE; docs/paper/REBUILD_NUMBERS.md section 9
 * (row 2026-10-11); docs/prod/SHIP_DECISION_7_3.md. */
export const IGNIS_MODELS = {
  served: {
    version: 'seasonal-ensemble:be23+lst1',
    label: 'ensemble sazonal (XGBoost + LightGBM, be23 e lst1)',
  },
  rebuilt: {
    version: 'offset-booster:2026-71b+iso25',
    label: 'modelo reconstruído (LightGBM sobre a tabela histórica por célula e mês)',
    shadowSince: '6 de outubro de 2026',
    /** Ignition coverage at 5 percent flagged area, 2026 fold of the rebuild harness. */
    coverage2026: { rebuilt: 36.6, lookup: 32.7, served: 16.4 },
    /** Live shadow tally, 5 percent arm, all ignitions, at STATE_DATE. */
    shadow: {
      liveDays: 4,
      liveFires: 128,
      live: { served: 15.6, lookup: 22.7, rebuilt: 28.9 },
      rebuiltMinusLookup: '+7,0 pontos [+3,4; +10,0]',
      allDays: 12,
      allFires: 390,
      all: { served: 12.8, lookup: 25.6, rebuilt: 29.5 },
    },
    /** The gate the switch waits for (G4 in the ship decision). */
    gate: { liveDays: 14, fires: 300, earliest: '19 de outubro de 2026' },
  },
} as const;

/** LIMES on production for Vila Franca de Xira.
 * Sources: docs/modules/limes/NOW.md (2026-09-07 and 2026-10-11 blocks). */
export const LIMES_STATE = {
  liveSince: '7 de setembro de 2026',
  namedAccounts: 4,
  orthoTiles: 394,
  unitsTotal: 5171,
  unitsEvaluated: 5041,
  verificar: 1082,
  reducao: 405,
  naoAvaliado: 9,
  s2Weeks: 64,
  /** Visual review of the 2024 -> 2025 change labels on native-resolution crops,
   * done 2026-10-11, AI-assisted, not yet validated by the municipality. */
  review: { total: 419, confirma: 223, agricola: 78, duvida: 88, naoConfirma: 16, coarse: 7 },
} as const;

/** House style: 5.041, 1.082 (pt-PT CLDR leaves four-digit numbers ungrouped). */
export function fmtInt(n: number): string {
  return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

export function fmtPct1(n: number): string {
  return `${n.toFixed(1).replace('.', ',')}%`;
}
